import { BaseApi, HttpMethodEnum } from '../BaseApi/BaseApi';

export class QuestionnaireExportApi extends BaseApi {
    private static baseApiUrl: string = `${BaseApi.apiUrl}/QuestionnaireExport`;

    public static apiUrls = {
        downloadZip: `${QuestionnaireExportApi.baseApiUrl}/HealthcareFacility`,
    };

    public static async downloadZip(healthcareFacilityId: number, password: string): Promise<Blob> {
        return this.sendApiRequest<Blob>({
            method: HttpMethodEnum.POST,
            path: `${this.apiUrls.downloadZip}/${healthcareFacilityId}`,
            data: { password },
            extraOptionsConfig: { responseType: 'blob' },
        });
    }
}
